hrd.dashboard.waitingMessage = function(options) {
	var defaults = {
		text: 'Waiting Message',
		icon: 'waiting',
		layerId: undefined,
		asynchOpen: false,
		width: 500
	};
	options = $.extend({}, defaults, options || {});
	var layerId = 'dashboard-waiting-layer' + (options.layerId ? '-' + options.layerId : '');
	var waitingBoxSelector = '#' + layerId;
	var waitingBoxContentSelector = '#' + layerId + ' > span';

	var toIconClasses = function(icon){
		switch (icon) {
		case 'warning':
			return 'dashboard-msgbox-icon ui-icon warning f-icon fas fa-exclamation-triangle';
		case 'info':
			return 'dashboard-msgbox-icon ui-icon info f-icon fas fa-info-circle';
		case 'error':
			return 'dashboard-msgbox-icon ui-icon error f-icon fas fa-times-circle';
		case 'help':
			return 'dashboard-msgbox-icon ui-icon help f-icon fas fa-question-circle';
		case 'waiting':
			return 'dashboard-msgbox-icon ui-icon waiting f-icon fas fa-circle-notch fa-spin fa-3x fa-fw';
		default:
			return 'dashboard-msgbox-icon ui-icon warning f-icon fas fa-exclamation-triangle';
		}
	};
	var $waitingBox = $(waitingBoxSelector);
	if(!$waitingBox.exists()){
		var tmpl =  '<div id="' + layerId + '" class="dashboard-msgbox ui-helper-hidden">' +
						'	<span>' +
					'		<span id="' + layerId + '-icon"></span>' +
					'		<span id="' + layerId + '-text" class="dashboard-waiting-layer-text"></span>' +
						'	</span>' +
						'</div>';
			$('body').append(tmpl);
		$waitingBox = $(waitingBoxSelector);
		}

	$waitingBox.dialog({
			autoOpen: false,
			resizable: false,
			closable: false,
			dialogClass: 'waiting-layer',
			height: 'auto',
			modal: true,
			close: function(event, ui){
				/* reset */
			$('#' + layerId + '-icon').attr('class', '');
			$('#' + layerId + '-text').html();
				$(document).off('.msgbox');
			},
			open: function(event, ui){
				$(this).height($(waitingBoxContentSelector).height() + 'px');
				$(document).on('keypress.msgbox', function(event){
					if(event.keyCode == 13){
						event.preventDefault();
					}
				}.bind(this));
			}
		});
		$(".waiting-layer .ui-dialog-titlebar").hide();

	$('#' + layerId + '-icon').addClass(toIconClasses(options.icon));
	$('#' + layerId + '-text').html(options.text);
	$waitingBox.dialog('option', 'width', options.width);
	$waitingBox.height($(waitingBoxContentSelector).height() + 'px');
	if(!options.asynchOpen){
		$waitingBox.dialog('open');
	}

	return {
		open: () => {
			$waitingBox.dialog('open');
			return $.when();
		},
		close: () => {
			$waitingBox.dialog('close');
			return $.when();
		}
	};
}